import { faCoins } from '@fortawesome/free-solid-svg-icons/faCoins';
import { FieldLabelIconMui5 } from 'components/atoms/FieldLabelIcon';
import Popover from 'components/molecules/Popover';
import Switch from 'components/molecules/Switch';
import { CarConditions } from 'shared/types/models';
import { UppercaseMui5 } from '../components';
import {
  SetFilterValue,
  useFilters,
} from '../../../../../services/filters/hooks/useFilters';
import { styled } from '@mui/material/styles';

const StyledPopover = styled(Popover)(({ theme }) => ({
  position: 'relative',
  top: theme.spacing(0.2),
}));

export const VehicleConditionFilter = ({
  setFilterValue,
  disabled = false,
}: {
  setFilterValue: SetFilterValue;
  disabled?: boolean;
}) => {
  const { filters } = useFilters();

  return (
    <Switch
      title={
        (
          <>
            <FieldLabelIconMui5 icon={faCoins} color='primary' />
            <UppercaseMui5>Deal Type </UppercaseMui5>
            <StyledPopover maxWidth={'300px'}>
              New vehicles have never been titled or registered. Loaner vehicles
              are either previous courtesy service loaners or executive demo
              vehicles.
            </StyledPopover>
          </>
        ) as any
      }
      value={filters.condition || ''}
      onChange={(
        e: React.MouseEvent<HTMLElement>,
        condition: string | null,
      ) => {
        if (condition == null || disabled) {
          return;
        }

        setFilterValue('condition', condition);
      }}
      size='small'
      items={[
        { value: '', label: 'All' },
        ...Object.keys(CarConditions).map((type) => ({
          value: CarConditions[type],
          label: type,
        })),
      ]}
      aria-label='text formatting'
    />
  );
};
